<template><ContactSubPage :title="{ 'zh-CN': '客户留言', 'en-US': 'Customer Message' }" /></template>
<script>
import ContactSubPage from "./ContactSubPage.vue";
export default { name: "MessagePage", components: { ContactSubPage } };
</script>
